import { getStorage } from "./storage";
import { isArrayWithLength } from "../../utils/array-methods";

function changeState(action, instanceIds, instances) {
  instances.forEach((instance) => {
    instanceIds.forEach((id) => {
      if (instance.ResourceId === id) {
        let state = "";
        switch (action) {
          case "terminate":
            state = "terminated";
            break;
          case "start":
            state = "running";
            break;
          case "restart":
            state = "running";
            break;
          case "stop":
            state = "stopped";
            break;
          default:
            state = instance.InstanceState;
            break;
        }
        instance.InstanceState = state;
      }
    });
  });

  return instances;
}

async function getAllInstanceIds() {
  const instances = await getStorage("INSTANCES");

  const instancesArray = [];
  isArrayWithLength(instances) &&
    instances.forEach((instance) => {
      instancesArray.push(instance.ResourceId);
    });
  return instancesArray;
}

export { changeState, getAllInstanceIds };
